import { Box, Grid, Link } from "@mui/material";
import React from "react";
import { Container } from "react-bootstrap";
import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";
import Sella from "./Sella.png";
import { useEffect } from "react";

const FailMessage = styled(Box)({
  fontFamily: 'Lato',
  fontSize: '18px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.44',
  letterSpacing: '0.13px',
  textAlign: 'center',
  color: '#f2662b',
});

const CompilaCampi = styled(Box)({
  fontFamily: "Lato",
  fontSize: "15px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.11px",
  textAlign: "center",
  color: "#7b7b7b",
});

const Intestazione = styled(Box)({
  fontFamily: "Montserrat, sans-serif",
  fontSize: "31px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "normal",
  textAlign: "center",
  color: "#1b1b1b",
});
const SimpleBox = styled(Box)({
  textAlign: "center",
});

const ButtonBox = styled(Box)({
  textAlign: "center",
  marginTop: "51px"
});

const HelperText = styled(Box)({
  marginTop: "472px",
  fontFamily: "Lato",
  fontSize: "13px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "1.54",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#919191",
});

const ContactLink = styled(Link)({
  fontFamily: "Lato",
  fontSize: "13px",
  fontWeight: "bold",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "1.54",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#00cb4d",
});
const Informativa = styled(Box)({
  marginBottom: "36px",
  opacity: "0.5",
  fontFamily: "Lato",
  fontSize: "13px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#333",
});
const CloseButton = styled(Button)({
  width: '300px',
  borderRadius: "0px",
  height: "50px",
  boxShadow: "none",
  textTransform: "none",
  fontFamily: "Montserrat, sans-serif",
  fontSize: "12px",
  fontWeight: "600",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#fff",
  backgroundColor: "#339aef",
  "&:hover": {
    backgroundColor: "#339aef",
  },
  "&:active": {
    backgroundColor: "#339aef",
  },
  "&:focus": {
    backgroundColor: "#339aef",
  },
});

function FailedForm() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <img src={Sella}></img>
        </Grid>
      </Grid>
      <br></br>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <Intestazione>Recupera il tuo Codice Cliente o Username</Intestazione>
        </Grid>
      </Grid>
      <br></br>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <CompilaCampi>
            Compila i campi per recuperare il Codice Cliente o Username
          </CompilaCampi>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={0} sm={0} md={3}></Grid>
        <Grid item xs={12} sm={12} md={6}>
          <div class="Line-8"></div>
        </Grid>
        <Grid item xs={0} sm={0} md={3}></Grid>
      </Grid>
      <br></br>

      <Grid container>
        <Grid item xs={0} sm={0} md={4}></Grid>
        <Grid item xs={12} sm={12} md={12}>
          <FailMessage>
            Autenticazione fallita!<br></br>
            Hai raggiunto il numero massimo di errori, probabilmente stai inserendo i dati errati.<br></br>
            Contatta l'assistenza per maggiori informazioni.
          </FailMessage>
        </Grid>
        <Grid item xs={0} sm={0} md={4}></Grid>
      </Grid>

      <br></br>
      <Grid container spacing={4}>
        <Grid item xs={0} sm={0} md={4}></Grid>
        <Grid item xs={12} sm={12} md={4}>
          <ButtonBox>
            <CloseButton fullWidth>CHIUDI</CloseButton>
          </ButtonBox>
        </Grid>
        <Grid item xs={0} sm={0} md={4}></Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <HelperText>
            Vuoi maggiori informazioni o hai bisogno di assistenza?
          </HelperText>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SimpleBox>
            <ContactLink href="/banca-on-line/contatti-e-assistenza">contatta il servizio clienti</ContactLink>
          </SimpleBox>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={0} sm={0} md={3}></Grid>
        <Grid item xs={12} sm={12} md={6}>
          <div class="Line-8"></div>
        </Grid>
        <Grid item xs={0} sm={0} md={3}></Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <Informativa>
            © 1996-2018 - Banca Sella S.p.A. - PI 02224410023 - Privacy
          </Informativa>
        </Grid>
      </Grid>


    </Container>
  );
}

export default FailedForm;
